import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.split";
export default function (obj, keys, val) {
  keys.split && (keys = keys.split('.'));
  var i = 0,
      l = keys.length,
      t = obj,
      x;

  for (; i < l; ++i) {
    x = t[keys[i]];
    t = t[keys[i]] = i === l - 1 ? val : x != null ? x : !!~keys[i + 1].indexOf('.') || !(+keys[i + 1] > -1) ? {} : [];
  }
}